module.exports = __webpack_public_path__ + "img/mt.8b4adb0b.jpg";